module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/banner/th-0e572e851f9a573b42af709b6ba64fb2.jpg";